<template>
  <div class="factoryTools">
    <div class="header">
      <el-tabs :value="tabPaneValue" @tab-click="tabPaneClick">
        <el-tab-pane label="产测工具" name="first">
          <span
            class="childTabs"
            :class="{ activeLink: toolsLink == 'firstLink' }"
            @click="toolsClick('firstLink')"
            >产测工具</span
          >
          <div class="btnBox">
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
              @click="factoryToolsAdd"
              >新建</el-button
            >
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-tooltip
                class="item"
                content="清除查询条件"
                placement="bottom"
                :open-delay="300"
              >
                <el-button
                  icon="iconfont icon-qingkong"
                  size="small"
                  class="cleanBox"
                  @click="onClear"
                ></el-button>
              </el-tooltip>
              <el-button type="primary" size="small" @click="onSearch"
                >查询</el-button
              >
            </div>
            <el-tooltip class="item" content="查询条件" placement="bottom" :open-delay="300">
              <el-button class="btn_more" :class="{ activeUserMore: isMoreSearch }" size="small" icon="el-icon-d-arrow-right" @click="moreSearchBtn"></el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>
        <el-tab-pane
          v-for="(item, index) in tabPaneList"
          :key="item.id"
          :label="item.name"
          :name="item.id"
        >
          <span slot="label">
            {{ item.name }}
            <i
              class="el-icon-circle-close"
              @click.stop="closeTabPane(index)"
            ></i>
          </span>
          <span
            class="childTabs"
            :class="{ activeLink: cutDetail == 'detail' }"
            @click="cutDetailChange('detail')"
            >工具详情</span
          >
          <span v-if="item.hasCommand"
            class="childTabs"
            :class="{ activeLink: cutDetail == 'commands' }"
            @click="cutDetailChange('commands')"
            >产测指令</span
          >
          <div class="btnBox">
            <el-button
              v-if="cutDetail == 'commands'"
              type="primary"
              icon="el-icon-plus"
              size="small"
              @click="factoryCommandAdd"
              >新建</el-button
            >
            <el-button
              v-if="cutDetail == 'detail'"
              type="primary"
              size="small"
              @click="factoryVerToolsAdd"
              >发布版本</el-button
            >
            <div class="searchBtnBox" v-if="isMoreSearch && cutDetail == 'commands'">
              <el-tooltip
                class="item"
                content="清除查询条件"
                placement="bottom"
                :open-delay="300"
              >
                <el-button
                  icon="iconfont icon-qingkong"
                  size="small"
                  class="cleanBox"
                  @click="onClear"
                ></el-button>
              </el-tooltip>
              <el-button type="primary" size="small" @click="$refs.commandPage.getFactoryCommandSearch()"
                >查询</el-button
              >
            </div>
            <el-tooltip
              v-if="cutDetail == 'commands'" class="item" content="查询条件" placement="bottom" :open-delay="300">
              <el-button class="btn_more" :class="{ activeUserMore: isMoreSearch }" size="small" icon="el-icon-d-arrow-right" @click="moreSearchBtn"></el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>
      </el-tabs>
      <!-- 查询条件 -->
      <el-form v-if="tabPaneValue == 'first' && isMoreSearch && toolsLink == 'firstLink'"
        :inline="true" :model="searchConditionForm" class="demo-form-inline">
        <div class="searchConditionBox">
          <el-form-item label="产测工具" size="small">
            <el-input v-model="searchConditionForm.name" placeholder="产测工具名称" clearable
              @keyup.enter.native="getFactoryToolsSearch()"></el-input>
          </el-form-item>
          <el-form-item label="产品类别" size="small">
            <el-select v-model="searchConditionForm.productType" placeholder="选择产品类别" filterable clearable>
              <el-option v-for="(item, index) in pullDownData.productTypeList" :key="index" :label="item.title" :value="item.code" ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <el-form v-if="cutDetail == 'commands' && isMoreSearch"
        :inline="true" :model="commandSearchForm" class="demo-form-inline">
        <div class="searchConditionBox">
          <el-form-item label="命令名称" size="small">
            <el-input v-model="commandSearchForm.title" placeholder="工具上显示的标题" clearable
              @keyup.enter.native="$refs.commandPage.getFactoryCommandSearch()"></el-input>
          </el-form-item>
          <el-form-item label="命令详情" size="small">
            <el-input v-model="commandSearchForm.name" placeholder="命令功能描述" clearable
              @keyup.enter.native="$refs.commandPage.getFactoryCommandSearch()"></el-input>
          </el-form-item>
          <el-form-item label="命令字" size="small">
            <el-input v-model="commandSearchForm.command" placeholder="嵌入式协议命令字" clearable
              @keyup.enter.native="$refs.commandPage.getFactoryCommandSearch()"></el-input>
          </el-form-item>
          <el-form-item label="所在工序" size="small">
            <el-select
              v-model="commandSearchForm.station"
              placeholder="选择所在工序"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.factoryStationList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="执行方式" size="small">
            <el-select
              v-model="commandSearchForm.type"
              placeholder="选择执行方式"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.commandTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="产测协议"
            size="small"
          >
          <el-select
              v-model="commandSearchForm.isTuyaCommand"
              placeholder="选择产测协议"
              filterable
              clearable
            >
            <el-option
                v-for="(item, index) in pullDownData.agreementList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <!-- 新增产测指令 -->
      <el-form
        :inline="true"
        :model="commandSearchForm"
        class="demo-form-inline"
        v-else-if="
          tabPaneValue == 'first' && isMoreSearch && toolsLink != 'firstLink'
        "
      >
        <div class="searchConditionBox">
          <el-form-item label="命令名称" size="small">
            <el-input
              v-model="commandSearchForm.name"
              placeholder="命令名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="产测协议" size="small">
            <el-select
              v-model="commandSearchForm.onlyTuya"
              placeholder="选择产测协议"
              filterable
              clearable
            >
            <el-option
                v-for="(item, index) in pullDownData.agreementList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所在工序" size="small">
            <el-select
              v-model="commandSearchForm.station"
              placeholder="选择所在工序"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.factoryStationList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="执行方式" size="small">
            <el-select
              v-model="commandSearchForm.type"
              placeholder="选择执行方式"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.commandTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <el-form
        :inline="true"
        :model="siteSearchForm"
        class="demo-form-inline"
        v-else-if="tabPaneValue == 'site' && isMoreSearch"
      >
        <div class="searchConditionBox">
          <el-form-item label="站点代码" size="small">
            <el-input
              v-model="siteSearchForm.code"
              placeholder="生产站点代码"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="站点名称" size="small">
            <el-input
              v-model="siteSearchForm.name"
              placeholder="生产站点名称"
              clearable
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!-- 产测工具列表 -->
    <div class="contentBox">
      <div
        class="rightContent"
        v-if="tabPaneValue == 'first' && toolsLink == 'firstLink'"
      >
        <el-table
          stripe
          :data="tableData"
          border
          style="width: 100%"
          height="100%"
          size="mini"
          @sort-change="sortChange"
          row-key="id"
          :cell-style="colStyle"
        >
          <el-table-column
            type="index"
            :width="pagination.endIndex >= 1000 ? 80 : 50"
            align="center"
            :index="pagination.beginIndex"
            class-name="drag_move"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="产测工具"
            max-width="110px"
            align="center"
            show-overflow-tooltip
            sortable="custom"
          >
            <template slot-scope="scope">
              <span class="allowSkip" :class="{disabled_user: !scope.row.enable}"
                @click="clickAllowSkip(scope.row)">
                {{ scope.row.name }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="productType"
            label="适用产品"
            align="center"
            max-width="110px"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.productType" :class="{disabled_user: !scope.row.enable}">
                {{scope.row.productType.title}}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="description"
            label="适用范围"
            min-width="110px"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.description"
                :class="{disabled_user: !scope.row.enable}">
                {{scope.row.description}}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="minBuild"
            label="最低版本"
            width="95px"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div v-if="scope.row.minBuild">
                <el-tooltip
                  v-if="scope.row.url"
                  class="item"
                  effect="dark"
                  :content="scope.row.url"
                  placement="top"
                  :open-delay="300"
                >
                  <span class="allowSkip" :class="{disabled_user: !scope.row.enable}"
                    @click="downloadFile(scope.row.url)">{{ scope.row.minBuild }}
                  </span>
                </el-tooltip>
                <span v-if="!scope.row.url" :class="{disabled_user: !scope.row.enable}">
                  {{ scope.row.minBuild }}
                </span>
              </div>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            class-name="operation"
            label="操作"
            align="center"
            width="95px"
          >
            <template slot-scope="scope">
              <el-tooltip
                v-if="scope.row.enable"
                class="item"
                effect="dark"
                content="禁用"
                placement="top"
                :open-delay="300"
              >
                <i
                  @click="disableTools($event, scope.row)"
                  class="iconfont icon-jinyong"
                ></i>
              </el-tooltip>
              <el-tooltip
                v-else
                class="item"
                effect="dark"
                content="启用"
                placement="top"
                :open-delay="300"
              >
                <i
                  @click="enableTools($event, scope.row)"
                  class="iconfont icon-qiyong"
                ></i>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="上移"
                placement="top"
                :open-delay="300"
              >
                <i
                  @click="moveUpTools($event, scope.row)"
                  class="el-icon-arrow-up"
                ></i>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="下移"
                placement="top"
                :open-delay="300"
              >
                <i
                  @click="moveDownTools($event, scope.row)"
                  class="el-icon-arrow-down"
                ></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :pagination="pagination"
          @currentChange="currentChange"
          @sizeChange="sizeChange"
          @refreshBtn="getFactoryToolsSearch"
        ></pagination>
      </div>
      <!-- 产测工具详情 -->
      <div
        class="rightContent"
        v-else-if="tabPaneValue != 'first' && cutDetail == 'detail'"
      >
        <detailPage
          ref="detailPage"
          :factoryToolId="tabPaneValue"
          :tabPaneValue="tabPaneValue"
        ></detailPage>
      </div>
      <!-- 产测工具指令 -->
      <div
        class="rightContent"
        v-else-if="tabPaneValue != 'first' && cutDetail == 'commands'"
      >
        <commandPage
          ref="commandPage"
          :factoryToolId="tabPaneValue"
          :commandSearchForm="commandSearchForm"
        ></commandPage>
      </div>
      <div class="rightContent" v-else-if="tabPaneValue == 'site'">
        <sitePage ref="sitePage" :siteSearchForm="siteSearchForm"></sitePage>
      </div>
    </div>
    <myDialog ref="myDialog"
      :title="dialogTitle" @submitData="submitData" @dialogClose="dialogClose">
      <!-- width="700px" -->
      <template slot="content">
        <el-form ref="dialogForm" :model="dialogForm" :rules="dialogRules" :label-width="labelWidth">
          <el-form-item label="产测工具" size="small" prop="name">
            <el-input v-model="dialogForm.name"
              placeholder="输入产测工具名称" clearable>
            </el-input>
          </el-form-item>
          <el-form-item label="产品类别" size="small" prop="productType">
            <el-select v-model="dialogForm.productType" placeholder="选择产品类别" filterable clearable>
              <el-option v-for="(item, index) in pullDownData.productTypeList"
                :key="index" :label="item.title" :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="安装包(*.zip)" size="small" prop="uploadFile">
            <input ref="fileUpload"
              class="fileUpload" type="file" @change="fileChange('fileUpload')"/>
          </el-form-item>
          <el-form-item label="版本号" size="small" prop="minBuild">
            <el-input :value="dialogForm.minBuild"
              @input="formatNumber($event, 'dialogForm', 'minBuild')" placeholder="版本号" clearable></el-input>
          </el-form-item>
          <el-form-item label="适用范围" size="small" prop="description">
            <el-input v-model="dialogForm.description"
              type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="描述产测工具可以用的产品范围或使用场景"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
  </div>
</template>

<script>
import Sortable from "sortablejs";
import pagination from "@/components/pagination.vue";
import myDialog from "@/components/myDialog.vue";
import commandPage from "./components/commandPage.vue";
import sitePage from "./components/sitePage.vue";
import detailPage from "./components/detailPage.vue";
import { apiUploadFile } from "@/api/filesUpload.js";
import {
  apiFactoryToolsSearch,
  apiFactoryToolsAdd,
  apiToolsUpdateVersion,
  apiFactoryToolsDisable,
  apiFactoryToolsEnable,
  apiFactoryToolsMoveDown,
  apiFactoryToolsMoveUp,
  apiProductTypeList,
  apiFactoryStationList,
  apiCommandTypeList, apiFactoryToolsDragSort,
  apiFactoryAgreement,
} from "@/api/factoryTools.js";
import { apiWorkStationList } from "@/api/productionOrder.js";
export default {
  lastModuleConfig: { modulePath: "/homePage/factoryTools" },
  components: {
    pagination,
    myDialog,
    commandPage,
    detailPage,
    sitePage,
  },
  data() {
    return {
      cutDetail: "detail",
      tabPaneValue: "first",
      toolsLink: "firstLink",
      tabPaneList: [],
      isMoreSearch: false,
      searchConditionForm: {},
      commandSearchForm: {},
      siteSearchForm: {},
      pullDownData: {
        productTypeList: [],
        factoryStationList: [],
        commandTypeList: [],
        agreementList: [],
        workStationList:[],
      },
      tableData: [],
      desc: undefined,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10,
      },
      dialogTitle: "",
      dialogForm: {},
      dialogRules: {
        name: [
          { required: true, message: "工具名称不能为空！", trigger: "blur" },
          {
            min: 4,
            max: 32,
            message: "长度在 4 到 32 个字符",
            trigger: "change",
          },
        ],
        minBuild: [
          { required: true, message: "版本号不能为空！", trigger: "blur" },
          // {
          //   min: 2,
          //   max: 64,
          //   message: "长度在 2 到 64 个字符",
          //   trigger: "change"
          // }
        ],
      },
      labelWidth: this.$store.state.labelWidth,
    };
  },
  watch: {
    tabPaneValue: function () {
      this.$moreSearchStyle();
      if (this.tabPaneValue == "first") {
        if (this.toolsLink == "firstLink") {
          this.getFactoryToolsSearch();
        } else {
          this.$nextTick(() => {
            this.$refs.commandPage.getFactoryCommandSearch();
          });
        }
      } else if (this.tabPaneValue != "first" && this.cutDetail == "commands") {
        this.$nextTick(() => {
          this.$refs.commandPage.getFactoryCommandSearch();
        });
      } else if (this.tabPaneValue != "first" && this.cutDetail == "detail") {
        this.$nextTick(() => {
          this.$refs.detailPage.getFactoryToolsDetail();
          this.$refs.detailPage.getFactoryToolsHisSearch();
        });
      }
    },
    toolsLink: function (newVal) {
      this.$moreSearchStyle();
      if (newVal == "firstLink") {
        this.getFactoryToolsSearch();
      } else {
        this.$nextTick(() => {
          this.$refs.commandPage.pagination.currentPage = 1;
          this.$refs.commandPage.getFactoryCommandSearch();
        });
      }
    },
  },
  mounted () {
    this.rowDrop();
  },
  methods: {
    // 文件上传
    async fileChange(refName) {
      this.$set(this.dialogForm, "uploadFile", this.$refs[refName].files[0]);
      this.$refs.dialogForm.validateField("uploadFile");
      // console.log(file)
    },
    // 文件下载
    downloadFile(url) {
      let a = document.createElement("a");
      a.href = url;
      a.style.display = "none";
      a.target = "_blank"
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    // 切换一级面板
    tabPaneClick(tab) {
      this.tabPaneValue = tab.name;
    },
    // 关闭一级面板
    closeTabPane(index) {
      if (this.tabPaneList[index].id == this.tabPaneValue) {
        if (index > 0) {
          this.tabPaneValue = this.tabPaneList[index - 1].id;
        } else {
          this.tabPaneValue = "first";
        }
      }
      this.tabPaneList.splice(index, 1);
    },
    // 切换详情-二级面板
    cutDetailChange(value) {
      this.cutDetail = value;
      this.$moreSearchStyle();
      this.$nextTick(() => {
        if (value == "detail") {
          this.$refs.detailPage.getFactoryToolsDetail();
          this.$refs.detailPage.getFactoryToolsHisSearch();
        } else if (value == "commands") {
          this.$refs.commandPage.getFactoryCommandSearch();
          // this.$refs.devicesPage.getShipmentOrderDevices("", () => {
          //   this.$refs.devicesPage.getCartonOrderList();
          //   this.$refs.devicesPage.getProductionOrders();
          // });
        }
      });
    },
    // 表格列发货单号点击
    clickAllowSkip(row) {
      this.tabPaneValue = row.id;
      let tabPaneIds = this.tabPaneList.map((item) => item.id);
      if (tabPaneIds.includes(row.id)) {
        this.tabPaneList.splice(tabPaneIds.indexOf(row.id), 1, row);
      } else {
        this.tabPaneList.push(row);
      }
    },
    // 表格数据
    async getFactoryToolsSearch(remove, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiFactoryToolsSearch({
        ...this.searchConditionForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy,
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        // console.log(this.tableData);
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if (callback) callback();
      }
    },
    // 更多查询
    moreSearchBtn() {
      this.isMoreSearch = !this.isMoreSearch;
      this.$moreSearchStyle();
    },
    // 添加产测工具
    factoryToolsAdd() {
      this.dialogTitle = "新建产测工具";
      this.$refs.myDialog.dialogVisible = true;
    },
    // 格式化整数
    formatNumber(value, formName, name) {
      let newValue = value.replace(/[^\d]/g, "");
      this.$set(this[formName], name, newValue);
    },
    // 确认新建
    submitData(title) {
      this.$refs.dialogForm.validate(async (valid) => {
        if (valid) {
          if (title == "新建产测工具") {
            let res = {};
            let fd = new FormData();
            fd.append("file", this.dialogForm.uploadFile);
            res = await apiUploadFile(fd);
            if (res.code == 0) {
              this.$set(this.dialogForm, "fid", res.fid);
            } else {
              return false;
            }
            res = await apiFactoryToolsAdd({
              ...this.dialogForm,
            });
            // console.log(res);
            if (res.code == 0) {
              this.$refs.myDialog.dialogVisible = false;
              this.pagination.currentPage = 1;
              this.getFactoryToolsSearch();
              this.$message({
                message: "新增成功",
                type: "success",
              });
            }
          }
        } else {
          return false;
        }
      });
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.dialogForm.resetFields();
      this.dialogForm = {};
      this.$refs.fileUpload.value = "";
    },
    // 清除查询
    onClear() {
      if (this.tabPaneValue == "first") {
        if (this.toolsLink == "firstLink") {
          this.searchConditionForm = {};
          this.pagination.currentPage = 1;
          this.getFactoryToolsSearch();
        } else {
          this.commandSearchForm = {};
          this.$refs.commandPage.pagination.currentPage = 1;
          this.$nextTick(() => {
            this.$refs.commandPage.getFactoryCommandSearch();
          });
        }
      } else if (this.tabPaneValue == "site") {
        this.siteSearchForm = {};
        this.$refs.sitePage.pagination.currentPage = 1;
        this.$nextTick(() => {
          this.$refs.sitePage.getProductionActionSearch();
        });
      } else {
        this.commandSearchForm = {};
        this.$refs.commandPage.pagination.currentPage = 1;
        this.$nextTick(() => {
          this.$refs.commandPage.getFactoryCommandSearch();
        });
      }
    },
    // 确认查询
    onSearch() {
      if (this.tabPaneValue == "first") {
        if (this.toolsLink == "firstLink") {
          this.pagination.currentPage = 1;
          this.getFactoryToolsSearch();
        } else {
          this.$refs.commandPage.pagination.currentPage = 1;
          this.$refs.commandPage.getFactoryCommandSearch();
        }
      }
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getFactoryToolsSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getFactoryToolsSearch();
    },
    // 修改版本
    editVersionBtn(e, row) {
      e.target.blur();
      const h = this.$createElement;
      this.$prompt("", "", {
        title: `提示`, // 请输入新的最新版本号
        message: h("div", null, [
          h("span", null, `当前最低版本号：【`),
          h("i", { style: "color: var(--themeColor)" }, row.minBuild),
          h("span", null, `】，请输入新的版本号！`),
        ]),
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^\+?[1-9][0-9]*$/,
        inputErrorMessage: "版本号格式为正整数",
      }).then(async ({ value }) => {
        const res = await apiToolsUpdateVersion({
          id: row.id,
          minBuild: value,
        });
        if (res.code == 0) {
          this.getFactoryToolsSearch("noRemove");
          this.$message({
            type: "success",
            message: "修改成功",
          });
        }
      });
    },
    // 禁用
    disableTools(e, row) {
      e.target.blur();
      this.$allOperation(row, "禁用", "工具").then(async () => {
        const res = await apiFactoryToolsDisable({
          id: row.id,
        });
        // console.log(res)
        if (res.code == 0) {
          this.getFactoryToolsSearch("noRemove");
          this.$message({
            message: "禁用成功",
            type: "success",
          });
        }
      });
    },
    // 启用
    enableTools(e, row) {
      e.target.blur();
      this.$allOperation(row, "启用", "工具").then(async () => {
        const res = await apiFactoryToolsEnable({
          id: row.id,
        });
        // console.log(res)
        if (res.code == 0) {
          this.getFactoryToolsSearch("noRemove");
          this.$message({
            message: "启用成功",
            type: "success",
          });
        }
      });
    },
    // 上移
    moveUpTools(e, row) {
      e.target.blur();
      this.$confirm(`是否上移【${row.name}】？`, "上移工具", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiFactoryToolsMoveUp({
          id: row.id,
        });
        // console.log(res)
        if (res.code == 0) {
          this.getFactoryToolsSearch("noRemove");
          this.$message({
            message: "上移成功",
            type: "success",
          });
        }
      });
    },
    // 下移
    moveDownTools(e, row) {
      e.target.blur();
      this.$confirm(`是否下移【${row.name}】？`, "下移工具", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiFactoryToolsMoveDown({
          id: row.id,
        });
        // console.log(res)
        if (res.code == 0) {
          this.getFactoryToolsSearch("noRemove");
          this.$message({
            message: "下移成功",
            type: "success",
          });
        }
      });
    },
    // 添加产测命令
    factoryCommandAdd() {
      this.$refs.commandPage.factoryCommandAdd();
    },
    //版本发布
    factoryVerToolsAdd() {
      this.$refs.detailPage.factoryVerToolsAdd();
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getFactoryToolsSearch();
    },
    // 产品类别下拉数据
    async getProductTypeList() {
      const res = await apiProductTypeList();
      if (res.code == 0) {
        this.pullDownData.productTypeList = res.data;
      }
    },
    // 所在工序下拉数据
    async getFactoryStationList() {
      const res = await apiFactoryStationList();
      if (res.code == 0) {
        this.pullDownData.factoryStationList = res.data;
      }
    },
    // 执行方式下拉数据
    async getCommandTypeList() {
      const res = await apiCommandTypeList();
      if (res.code == 0) {
        this.pullDownData.commandTypeList = res.data;
      }
    },
    // 产测协议下拉数据
    async getFactoryAgreement() {
      const res = await apiFactoryAgreement();
      if (res.code == 0) {
        this.pullDownData.agreementList = res.data;
      }
    },
        // 生产工序-工序下拉
    async getWorkStationList() {
      const res = await apiWorkStationList();
      if (res.code == 0) {
        this.pullDownData.workStationList = res.data;
      }
    },
    callback() {
      this.getProductTypeList();
      this.getFactoryStationList();
      this.getCommandTypeList();
      this.getFactoryAgreement();
      this.getWorkStationList();
    },
    rowDrop() {
      const tbody = document.querySelector('.el-table__body-wrapper tbody');
      const _this = this;
      let tempName = '';
      let tempId = '';
      Sortable.create(tbody, {
        //  指定父元素下可被拖拽的子元素
        draggable: ".el-table__row",
        animation:500,
        handle: ".drag_move",
        onStart(evt) {
          const index=evt.oldIndex;
          const oldIndexRow  = _this.tableData.slice(index,index+1)[0];
          tempName = oldIndexRow.name;
          tempId = oldIndexRow.id;
        },
        onEnd ({ newIndex, oldIndex }) {
          if(newIndex == oldIndex){
            return;
          }
          let newIndexTemp = newIndex + 1;
          let oldIndexTemp = oldIndex + 1;
          // console.log(tempId);
          _this.$confirm('确定将【'+ tempName +'】从第【'+oldIndexTemp+'】行排序到第【'+newIndexTemp+'】行', "排序工具", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(async () => {
            const res = await apiFactoryToolsDragSort({
              id: tempId,
              sortNum: newIndex
            });
            console.log(res)
            if (res.code == 0) {
              _this.getFactoryToolsSearch("noRemove");
              _this.$message({
                message: "排序成功",
                type: "success",
              });
            }else {
              _this.getFactoryToolsSearch("noRemove");
            }
          }).catch(()=>{
            _this.getFactoryToolsSearch("noRemove");
          });
          const currRow = _this.tableData.splice(oldIndex, 1)[0];
          _this.tableData.splice(newIndex, 0, currRow);
          // _this.sortableResult = JSON.stringify(_this.tableData);
        }
      })

    },
    colStyle({columnIndex}) {
      if (columnIndex ==0) {
        return 'cursor: move;'
      }
    }

  },
  activated() {
    window.onresize = () => {
      document.querySelector(".contentBox").style.top =
        document.querySelector(".header").offsetHeight + "px";
    };
    if (this.tabPaneValue == "first") {
      if (this.toolsLink == "firstLink") {
        this.getFactoryToolsSearch("", this.callback);
      } else {
        this.$nextTick(() => {
          this.$refs.commandPage.getFactoryCommandSearch("", this.callback);
        });
      }
    } else if (this.tabPaneValue == "site") {
      this.$nextTick(() => {
        this.$refs.sitePage.getProductionActionSearch("", this.callback);
      });
    }
  },
  deactivated() {
    window.onresize = null;
  },

};
</script>

<style lang="less" scoped>
.disabled_user {
  text-decoration: line-through;
}
.drag_move {}
</style>
